<template>
  <!-- Generate GRN modal -->
  <v-dialog v-model="dialog" max-width="600px" persistent>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        color="primary"
        rounded
        v-bind="attrs"
        v-on="on"
        v-if="purchase_order.status != 3"
        >Generate GRN</v-btn
      >
    </template>
    <v-card>
      <v-form v-model="grnForm" :ref="grnForm">
        <v-card-title>
          <span class="headline">Generate GRN</span>
          <v-spacer></v-spacer>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click="discardChanges"
              >Discard</v-btn
            >
            <v-btn
              color="blue darken-1"
              :disabled="!grnForm"
              text
              @click="submitGRN"
              >Save</v-btn
            >
          </v-card-actions>
        </v-card-title>
        <p class="text-left mx-4 my-0">GRN Number will be autogenerated.</p>

        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="purchase_order.order_number"
                  label="Purhcase Order"
                  disabled
                  hide-details="auto"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="grn.invoice_number"
                  label="Invoice Number *"
                  :prefix="purchase_order.store_item.store.invoice_prefix"
                  :rules="[rules.required]"
                  hide-details="auto"
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="grn.batch_number"
                  label="Batch Number *"
                  :rules="[rules.batch_number]"
                  hide-details="auto"
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                 <v-select
                      prepend-icon="mdi-credit-card-outline"
                      label="Payment Mode *"
                      :rules="[rules.requiredOr0]"
                      v-model="grn.payment_mode"
                      :items="paymentModes"
                      item-value="type"
                      hide-details="auto"
                      item-text="title"
                    ></v-select>
              </v-col>
              <v-col cols="6">
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  :return-value.sync="grn.invoice_date"
                  transition="scale-transition"
                  offset-y
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      label="Invoice Date"
                      :value="formattedDate(grn.invoice_date)"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      hide-details="auto"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="grn.invoice_date" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menu = false"
                      >Cancel</v-btn
                    >
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.menu.save(grn.invoice_date)"
                      >OK</v-btn
                    >
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="grn.other_charges"
                  label="Other Charges (₹) *"
                  type="number"
                  min="0"
                  value="0"
                  hide-details="auto"
                  :rules="[rules.requiredOr0, rules.no_negative]"
                ></v-text-field>
              </v-col>
              <v-col cols="6" v-if="financePreferences && financePreferences.link_inventory">
                <v-autocomplete
                    v-model="selected_finance_account"
                    label="Debit Account*"
                    :rules="[ rules.required ]"
                    :items="financeAccounts.filter(
                          acc =>
                            !acc.restrict_creators ||
                            acc.allowed_creators.includes(currentUser.id)
                        )"
                    item-text="name"
                    item-value="id"
                    
                  >
                </v-autocomplete>
              </v-col>

              <v-col cols="12">
                <v-textarea
                  v-model="grn.notes"
                  label="Notes"
                  hide-details="auto"
                  rows="3"
                  auto-grow
                ></v-textarea>
              </v-col>
              <v-col cols="12">
                <v-file-input
                  @change="fileCallBack"
                  label="Invoice File"
                ></v-file-input>
              </v-col>
            </v-row>
          </v-container>
          <small>*indicates required field</small>
        </v-card-text>
      </v-form>
    </v-card>
    <v-snackbar v-model="snackbar.visible">
      {{ snackbar.text }}
      <template>
        <v-btn color="pink" text @click="snackbar.visible = false">Close</v-btn>
      </template>
    </v-snackbar>
  </v-dialog>
</template>

<script>
import api from "@api/index";
import endpoints from "@api/repository";
import Helper from "@utils/misc";

import { mapGetters, mapActions } from "vuex";
import moment from "moment";

export default {
  name: "GenerateGRN",
  props: {
    purchase_order: {
      default: null,
      type: Object,
    },
  },
  data() {
    return {
      rules: {
        required: (value) => !!value || "Required",
        requiredOr0: (value) => value === 0 || !!value || "Required",
        no_negative: (value) => value >= 0 || "Invalid",
        batch_number: (v) => !v || /^[a-zA-Z0-9_ ]{1,55}$/.test(v) || "Invalid",

      },
      menu: false,
      grnForm: true,
      grn: {
        GRN_number: null,
        purchase_order: {
          id: null,
        },
        invoice_number: null,
        batch_number: null,
        invoice_date: new Date().toJSON(),
        other_charges: 0,
        has_documents: false,
        invoice_file: null,
        payment_mode: null,
        notes: null,
      },
      selected_finance_account: null,
      financePreferences: null,
      financeAccounts: [],
      snackbar: {
        text: "",
        visible: false,
      },
      moment: moment,
      dialog: false,

      paymentModes: [
        {
          type: 0,
          title: "Cash",
        },
        {
          type: 1,
          title: "Cheque",
        },
        {
          type: 2,
          title: "DD",
        },
        {
          type: 3,
          title: "NEFT/RTGS",
        },
        {
          type: 4,
          title: "Online/Net Banking",
        },
        {
          type: 5,
          title: "Debit Card",
        },
        {
          type: 6,
          title: "Credit Card",
        },
      ],

    };
  },
  computed: {
    ...mapGetters(["accessToken", "currentUser","currentInstitution"]),
    apiEssentials() {
      return {
        accessToken: this.accessToken,
        handleErrorsFunction: this.handleApiErrors,
        setLoading: this.setLoading,
      };
    },
  },
  methods: {
    ...mapActions(["setLoading"]),
    async submitGRN() {
      var response;
      response = await api.handleApi({
        apiEssentials: this.apiEssentials,
        url: endpoints.grns,
        responseVar: response,
        method: api.Methods.POST,
        body: {
          purchase_order_id: this.purchase_order.id,
          invoice_number: this.grn.invoice_number,
          invoice_date: this.grn.invoice_date,
          other_charges: this.grn.other_charges,
          invoice_file: this.grn.invoice_file,
          batch_number: this.grn.batch_number,
          notes: this.grn.notes,
          has_documents: this.grn.has_documents,
          payment_mode: this.grn.payment_mode,
          debit_account: this.selected_finance_account,
        },
      });
      if (response.purchase_order.status==3) {
        this.$emit("changedResponse", response);
        console.log(response);
        this.dialog = false;
      }
    },

    discardChanges() {
      this.$emit("discardChanges");
      this.dialog = false;
    },

    formattedDate(date) {
      if (!date) return "";
      return moment(date).format("D MMM YYYY");
    },

    async getFinancePreferences(){
      var url = endpoints.financePreferences + `${this.currentInstitution.id}/`;
      this.financePreferences = await api.call(this.apiEssentials,url)
      if(this.financePreferences?.link_inventory){
        this.financeAccounts = await api.call(this.apiEssentials,endpoints.financeAccounts);
      }
    },

    async fileCallBack(file) {
      // console.log("studentImageCallback");
      if (!file) {
        this.grn.invoice_file = null;
        this.grn.has_documents = false;
        return;
      }
      this.grn.has_documents = true;
      this.grn.invoice_file = await Helper.toBase64(file);
    },

    async handleApiErrors(err) {
      this.setLoading(false);
      console.log(err);
      if (err.response) {
        console.log(err.response);
        if (err.response.status == 409) {
          this.snackbar.text = err.response.data.message;
          console.log(err.response.data.message)
          this.snackbar.visible = true;
        }
      } else {
        this.snackbar.text = "Unable to process request";
        this.snackbar.visible = true;
      }
    },
  },
  created(){
    this.getFinancePreferences();
  }
};
</script>